module.exports = __webpack_public_path__ + "img/Abrollbehälter_Container.23cab925.svg";